const routes = [{
    path: '/main',
    name: 'main',
    beforeEnter(to, from, next) {
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
            next({
                name: "m" + to.name
            })
            return;
        }
        next()
    },
    component: () => import('../views/main'),
    children: [{
        path: '/home',
        name: 'home',
        component: () => import('../views/home')
    },
        {
            path: '/crypto',
            name: 'crypto',
            component: () => import('../views/crypto')
        },
        {
            path: '/virtualCard',
            name: 'virtualCard',
            component: () => import('../views/virtualCard')
        },
        {
            path: '/aboutUbpay',
            name: 'aboutUbpay',
            component: () => import('../views/aboutUbpay')
        },
        {
            path: '/privacyPolicy',
            name: 'privacyPolicy',
            component: () => import('../views/privacyPolicy')
        },
        {
            path: '/contactUs',
            name: 'contactUs',
            component: () => import('../views/contactUs')
        },
        {
            path: '/multiWalletAndCcy',
            name: 'multiWalletAndCcy',
            component: () => import('../views/multiWalletAndCcy')
        },
        {
            path: '/transformCcy',
            name: 'transformCcy',
            component: () => import('../views/transformCcy')
        },
        {
            path: '/security',
            name: 'security',
            component: () => import('../views/security')
        },
        {
            path: '/footerVirtualCard',
            name: 'footerVirtualCard',
            component: () => import('../views/footerVirtualCard')
        },
        {
            path: '/payment',
            name: 'payment',
            component: () => import('../views/payment')
        },
        {
            path: '/appDownload',
            name: 'appDownload',
            component: () => import('../views/appDownload')
        },
        {
            path: '/termsOfUse',
            name: 'termsOfUse',
            component: () => import('../views/termsOfUse')
        },
        {
            path: '/helpCenter',
            name: 'helpCenter',
            component: () => import('../views/helpCenter')
        }
    ]
}
]
export default routes
